import { render, staticRenderFns } from "./ClientActionButtons.vue?vue&type=template&id=7feaa87a&scoped=true&"
import script from "./ClientActionButtons.vue?vue&type=script&lang=js&"
export * from "./ClientActionButtons.vue?vue&type=script&lang=js&"
import style0 from "./ClientActionButtons.vue?vue&type=style&index=0&id=7feaa87a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7feaa87a",
  null
  
)

export default component.exports